import { useContext } from 'react'

import { AlertPurchseContext } from '@provider/Alerts/AlertPurchaseProvider'

import { IAlertPurchaseContext } from '@base/@types/providers/Alert/AlertPurchaseProvider'

export default function useAlertPurchase(): IAlertPurchaseContext {
  const context = useContext(AlertPurchseContext)

  return context
}
